import React from 'react';

const UncheckedIcon = ({ width = 24, height = 24 }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width={width} height={height}>
    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
  </svg>
);

export default UncheckedIcon;
